import React from 'react';
import Keycloak from 'keycloak-js';
import { AbilityContext } from '@nic-react/ability';
import { useTranslation } from '@nic-react-i18n/core';
import dayjs from 'dayjs';
import { AppConf } from '../AppConf';

export const setUrlToHTTPs = (url: string): string => {
    return url.replace('http://', 'https://');
};
export function isNullOrUndefined(value: any) {
    return value === null || value === undefined;
}
export const notNullOrUndefined = (value: any): boolean => {
    return (value !== null && value !== undefined)
}


export const resolveUrl = (
    url: string,
    queryParams: Record<string, string | string[]> = {},
    pathParams: Record<string, string> = {}
) => {

    let urlSearchParams = new URLSearchParams();

    Object.keys(queryParams).forEach((key: string) => {
        const queryValue = queryParams[key];
        if (Array.isArray(queryValue)) {
            for (let i=0; i< queryValue.length; i++) {
                urlSearchParams.append(key, queryValue[i])
            }
        } else {
            urlSearchParams.append(key, queryValue)
        }

    })

    let query = urlSearchParams.toString();
    if (query) query = `?${query}`;
    return url.replace(/\{\w*\}/g, (key) => pathParams[key.slice(1, -1)]) + query;
};


export const queryKeyFn = (resolvedPath: string, queryParams?: any, body?: any) => {
    const queryKey: unknown[] = resolvedPath.split("/").filter(Boolean);

    if (queryParams !== undefined) {
        queryKey.push(queryParams);
    }

    if (body !== undefined) {
        queryKey.push(body);
    }

    return queryKey;
};


export const hasRole = (keycloak: Keycloak, role: string): boolean => {
    const {tokenParsed} = keycloak
    const realmRoles = tokenParsed?.realm_access?.roles ?? []
    const resourceRoles = tokenParsed?.resource_access?.roles?.roles ?? []
    const roles = [...realmRoles, ...resourceRoles]
    return roles.includes(role)
}


export const useAbility = () => {
    const ability = React.useContext(AbilityContext)
    return ability
}


export const convertDate = (locale: string, date: Date, dataConversion?: Intl.DateTimeFormatOptions): string => {
    const o = dataConversion ?? {
        year: "numeric",
        month: "long",
        day: "numeric"
    }
    //  console.log('DataConverion?: ', o, locale, date);
    return new Intl.DateTimeFormat(locale, o).format(date);
}


export const FULL_DATE_CONF: Intl.DateTimeFormatOptions = {
    weekday: 'short',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
}

export const SIMPLE_DATE_CONF: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
}
export const BASIC_DATE_CONF: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
}

export const CALENDAR_DATE_CONF: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric"
}
export const SIMPLE_CALENDAR_DATE_CONF: Intl.DateTimeFormatOptions = {
    month: "long",
    year: "numeric",
}
export const WEEKDAY_CONF: Intl.DateTimeFormatOptions = {
    weekday: "long"
}


export const DATE_CONF: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
}

export const TIME_CONF: Intl.DateTimeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit"
}
export const MONTH_CONF: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: 'long'
}
export const WEEK_CONF: Intl.DateTimeFormatOptions = {
    weekday: "long"
}

export const YEAR_CONF: Intl.DateTimeFormatOptions = {
    year: 'numeric'
}

export const formatter: Record<string,Intl.DateTimeFormatOptions> = {
    day: CALENDAR_DATE_CONF,
    month: MONTH_CONF,
    week: WEEK_CONF,
    year: YEAR_CONF
};

export const useBuildDateLabel = (next: dayjs.Dayjs, period?: string): string => {
    console.log('buildDateLabel: period: ', period)
    const {t, locale} = useTranslation()

    let res: string;
    switch (period) {
        case 'day':
        case 'week':
            let d = convertDate(locale, dayjs(next).toDate(), formatter['year'])
            res = `${t(`title.${period}`)} ${d}`;
            break;
        case 'month':
            res = convertDate(locale, dayjs(next).toDate(), formatter['month'])
            break
        case 'range':
            res = '';
            break;
        default:
            res = convertDate(locale, dayjs(next).toDate(), formatter['year'])
            break;
    }
    return res;
}

export const getQueryObj = (searchParams: URLSearchParams, queryConf: Record<string, string>) => {
    let res: any = {}
    // console.log('SearchParams: ', searchParams)
    const qKeys = Object.keys(queryConf);
    for (let k=0; k<qKeys.length; k++) {
        const qq = searchParams.getAll(qKeys[k]);
        //  console.log('SeachValue: ', qKeys[k], qq);
        if (qq !== null) {
            res[qKeys[k]] = qq;
        }
    }
    return res;
}


export const urlSanity = (realm: string, url: string | undefined) : string | undefined => {
    let res = url
    if (url !== undefined) {
        const { url:rootApi} = AppConf.getRootUrl(realm)
        if (!url.startsWith(rootApi)) {
            const _url = new URL(url)
            //console.log("TypeController: ", _url, _url.pathname)
            res = rootApi+_url.pathname
        }
    }
    return res
}